<template>
    <div class="grid titre-section" :class="cssClass" v-show="visible">
        <cogi-image :image="imageIcone" class="grid-begining" />
        <cogi-label :cssClass="labelCssClass" cssClassLabel="titre-section indentation" :label="titre" :tooltip="tooltip" />
        <cogi-langue cssClass="grid-end" v-model="model" :visible="utiliseMultilangue" :langues="langues" />
    </div>
</template>
<script setup lang="ts">
    import { watch, computed } from 'vue'
    import CogiImage from './CogiImage.vue'
    import CogiLabel from './CogiLabel.vue'
    import CogiLangue from './CogiLangue.vue'
    import { ImageUtil } from './helpers/imageutil'
    import { i18n } from '@/locales/i18n-wc'
    import { useI18n } from 'vue-i18n'
    const globalLocale = useI18n().locale

    interface IPropsTitreSection {
        titre: string
        tooltip?: string
        visible?: boolean
        cssClass?: string
        utiliseMultilangue: boolean
        langues: Array<string>
        imageIcone?: object
    }

    const props = withDefaults(defineProps<IPropsTitreSection>(), {
        titre: '',
        tooltip: '',
        visible: true,
        cssClass: '',
        utiliseMultilangue: false,
        langues: () => [],
    })

    const model = defineModel<'fr' | 'en'>({ required: true })

    const labelCssClass = computed(() => {
        return !ImageUtil.EstImageNulle(props.imageIcone as { extension: string; contenuBase64: string }) ? 'grid-full-with-begining-end' : 'grid-full-with-end'
    })

    watch(
        () => model.value,
        newValue => {
            globalLocale.value = newValue
            i18n.locale = newValue
        },
    )
</script>

<style scoped></style>
